import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ProjectForm } from 'components/Forms';
import { useForm, Controller } from 'react-hook-form';
import { Button, Card, IconButton, Box } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';

import logger from 'redux-logger';
import * as actions from '../../redux/actions';
import api from '../../utils/functions/api';
import { confirmAsync } from '../../utils/functions/globalDialog';

export default function EditProject({ title, subtitle }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const history = useHistory();
  const project = useSelector((state) => state.project);
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
    setValue,
  } = useForm();

  const [date, setDate] = useState(project?.date_start);
  const [dateEnd, setDateEnd] = useState(project?.date_end);
  const [includeVAT, setIncludeVAT] = useState(false);
  const [cost, setCost] = useState(); // State for cost input
  const [extraGpsSites, setExtraGpsSites] = useState([]);
  const [allEmployees, setAllEmployees] = useState([]);

  useEffect(() => {
    dispatch(actions?.projectGet(id));

    const fetchAllEmployees = async () => {
      const PAGE_SIZE = 50;
      let pg = 1;
      let accumulated = [];
      let hasMore = true;
      while (hasMore) {
        const { data } = await api.get(
          `${process.env.REACT_APP_API_URL}/employee?name=&size=${PAGE_SIZE}&page=${pg}&activeOnly=false`,
        );
        const rows = data?.rows || [];
        const total = data?.total || 0;
        accumulated = [...accumulated, ...rows];
        setAllEmployees([...accumulated]);
        hasMore = accumulated.length < total && rows.length > 0;
        pg++;
      }
    };
    fetchAllEmployees();
    return () => {};
  }, []);

  useEffect(() => {
    setValue('engineer', project?.engineer?._id);
    setValue('name', project?.name);
    setValue('project_number', project?.project_number);
    setValue('description', project?.description);
    setValue('customer', project?.customer);
    setValue('place', project?.place);
    setValue('google_drive_url', project?.google_drive_url);
    setCost(project?.cost);
    setValue('labur_cost', project?.labur_cost);
    setValue('gps.lat', project?.gps?.lat);
    setValue('gps.lon', project?.gps?.lon);
    setIncludeVAT(project?.include_vat);
    const sites = project?.gps_sites;
    setExtraGpsSites(
      Array.isArray(sites) && sites.length
        ? sites.map((s) => ({
            name: s.name || '',
            lat: s.lat != null ? String(s.lat) : '',
            lon: s.lon != null ? String(s.lon) : '',
          }))
        : [],
    );

    return () => {};
  }, [project]);

  const onSubmit = async (data) => {
    const confirm = await confirmAsync('บันทึก');
    if (confirm) {
      const gpsSitesPayload = extraGpsSites
        .map((s) => ({
          name: (s.name || '').trim(),
          lat: s.lat !== '' && s.lat != null ? parseFloat(s.lat) : NaN,
          lon: s.lon !== '' && s.lon != null ? parseFloat(s.lon) : NaN,
        }))
        .filter((s) => Number.isFinite(s.lat) && Number.isFinite(s.lon));

      const latRaw = data?.gps?.lat ?? data['gps.lat'];
      const lonRaw = data?.gps?.lon ?? data['gps.lon'];
      const lat =
        latRaw !== '' && latRaw != null ? parseFloat(latRaw, 10) : NaN;
      const lon =
        lonRaw !== '' && lonRaw != null ? parseFloat(lonRaw, 10) : NaN;
      const gpsPayload =
        Number.isFinite(lat) && Number.isFinite(lon) ? { lat, lon } : undefined;

      const dataSubmit = {
        ...data,
        date_start: date,
        date_end: dateEnd,
        cost,
        vat: includeVAT ? 0 : cost * 0.07,
        include_vat: includeVAT,
        gps: gpsPayload,
        gps_sites: gpsSitesPayload,
      };

      dispatch(actions?.projectPut(id, dataSubmit));
      dispatch(actions?.projectGet(id));
      history.goBack();
    }
  };

  const renderForm = () => (
    <Card>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={'p-2'}>
          <ProjectForm
            Controller={Controller}
            control={control}
            date={date}
            setDate={setDate}
            dateEnd={dateEnd}
            setDateEnd={setDateEnd}
            employee={allEmployees}
            includeVAT={includeVAT}
            setIncludeVAT={setIncludeVAT}
            cost={cost}
            setCost={setCost}
            extraGpsSites={extraGpsSites}
            setExtraGpsSites={setExtraGpsSites}
          />
          <div className="flex justify-center">
            <Button variant="contained" type="submit">
              บันทึก
            </Button>
          </div>
        </div>
      </form>
    </Card>
  );
  return (
    <div>
      <Box sx={{ px: 1, pt: 1 }}>
        <IconButton size="small" onClick={() => history.goBack()} sx={{ color: 'text.secondary' }}>
          <ArrowBackIcon fontSize="small" />
        </IconButton>
      </Box>
      <div>{renderForm()}</div>
    </div>
  );
}
